export { ProgressBarKYC } from './ProgressBarKYC';
export { ProgressBarQuiz } from './ProgressBarQuiz';
